module.exports = __webpack_public_path__ + "img/action-9.ef55bdb8.svg";